import { host, initPath, xposParamsMap } from './constant';
/**
 * 获取最终的api地址
 * @param config
 * @param hostBranch
 * @returns
 */
/**
 * 根据传入的品牌、环境标识，返回正确的host
 */
function getHostByEnv(hostBranch = 'didi') {
    return host[hostBranch];
}
/**
 * 检查传入的参数是不是url
 * @param url
 * @returns
 */
function checkHttpsPrefix(url) {
    let pattern = /^(https?:\/\/|\/\/)/;
    return pattern.test(url);
}
/**
 * 根据传入的productInit的版本信息，返回对应的init接口路径
 */
function getWebxInitPath(version) {
    return initPath[version];
}
/**
 * 预请求业务接口封装
 * @param option 用户请求参数
 * @param requestFn 请求fn
 * @returns
 */
async function businessRequest(option, requestFn) {
    return requestFn(option.method, option.requestUrl, {
        ...option
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res) : Promise.reject(res));
}
/**
 * 跨端获取产品初始化配置-内部方法
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param nineChapterWebxParams 九章webx参数(sdk自动获取)
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
const _webxProductInit = (version, option, url, standardArguments, nineChapterWebxParams, sessionData, hostBranch, clusterId, requestFn) => {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    const path = getWebxInitPath(version);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid'],
        xoid: option['xoid'] || nineChapterWebxParams['xoid']
    });
    if (data.need_std_args)
        data.std_args = standardArguments || {};
    delete data.need_std_args;
    return requestFn(`${host}${path}`, data, {
        header: {
            'X-Cluster-Id': clusterId,
            'X-Prod-Key': data.prod_key || '',
        },
        isWebx: true,
        needSign: true
        // emulateJSON: true
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
};
const commonInitProduct = (...args) => {
    return _webxProductInit('v1', ...args);
};
const commonInitProductV2 = (...args) => {
    return _webxProductInit('v2', ...args);
};
const commonInitProductV3 = (...args) => {
    return _webxProductInit('v3', ...args);
};
/**
 * 跨端pageConfig公共方法
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param nineChapterWebxParams 九章webx参数(sdk自动获取)
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param isDebug 是否是页面预览服务
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
async function getCommonPageConfig(option, url, standardArguments, nineChapterWebxParams, sessionData, hostBranch, isDebug, clusterId, requestFn) {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    data.std_args = standardArguments;
    return requestFn(`${host}/webx/page/config${isDebug ? '?debug=1' : ''}`, data, {
        header: {
            'X-Cluster-Id': clusterId,
            'X-Prod-Key': data.prod_key || '',
        },
        isWebx: true,
        needSign: true
        // emulateJSON: true
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端pageBatchConfig公共方法
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param nineChapterWebxParams 九章webx参数(sdk自动获取)
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param isDebug 是否是页面预览服务
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
async function getCommonPageBatchConfig(option, url, standardArguments, nineChapterWebxParams, sessionData, hostBranch, isDebug, clusterId, requestFn) {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    data.std_args = standardArguments;
    return requestFn(`${host}/webx/chapter/page/batch/config${isDebug ? '?debug=1' : ''}`, data, {
        header: {
            'X-Cluster-Id': clusterId,
            'X-Prod-Key': data.prod_key || '',
        },
        isWebx: true,
        needSign: true
        // emulateJSON: true
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端shareConfig公共方法
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param nineChapterWebxParams 九章webx参数(sdk自动获取)
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
async function getCommonShareConfig(option, url, standardArguments, nineChapterWebxParams, sessionData, hostBranch, clusterId, requestFn) {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    data.std_args = standardArguments;
    return requestFn(`${host}/webx/chapter/share/config`, data, {
        header: {
            'X-Cluster-Id': clusterId,
            'X-Prod-Key': data.prod_key || '',
        },
        isWebx: true,
        needSign: true
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端shareConfig公共方法(APS)
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param nineChapterWebxParams 九章webx参数(sdk自动获取)
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
async function getCommonShareConfigV2(option, url, standardArguments, nineChapterWebxParams, sessionData, hostBranch, clusterId, requestFn) {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    data.std_args = standardArguments;
    return requestFn(`${host}/webx/v2/getShareConfig`, data, {
        header: {
            'X-Cluster-Id': clusterId,
            'X-Prod-Key': data.prod_key || '',
        },
        isWebx: true,
        needSign: true
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端shareBatchConfig公共方法
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param nineChapterWebxParams 九章webx参数(sdk自动获取)
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
async function getCommonShareBatchConfig(option, url, standardArguments, nineChapterWebxParams, sessionData, hostBranch, clusterId, requestFn) {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    data.std_args = standardArguments;
    return requestFn(`${host}/webx/chapter/share/batch/config`, data, {
        header: {
            'X-Cluster-Id': clusterId,
            'X-Prod-Key': data.prod_key || '',
        },
        isWebx: true,
        needSign: true
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端shareBatchConfig公共方法(APS)
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param nineChapterWebxParams 九章webx参数(sdk自动获取)
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
async function getCommonShareBatchConfigV2(option, url, standardArguments, nineChapterWebxParams, sessionData, hostBranch, clusterId, requestFn) {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    data.std_args = standardArguments;
    return requestFn(`${host}/webx/v2/getBatchShareConfig`, data, {
        header: {
            'X-Cluster-Id': clusterId,
            'X-Prod-Key': data.prod_key || '',
        },
        isWebx: true,
        needSign: true
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端coverConfig公共方法
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param nineChapterWebxParams 九章webx参数(sdk自动获取)
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
async function getCommonCoverConfig(option, url, standardArguments, nineChapterWebxParams, sessionData, hostBranch, clusterId, requestFn) {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    }, { dchn: option.dchn, xenv: option.xenv });
    data.std_args = standardArguments;
    return requestFn(`${host}/webx/chapter/cover/config`, data, {
        header: {
            'X-Cluster-Id': clusterId,
        },
        isWebx: true,
        needSign: true
        // emulateJSON: true
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端xaidConfig公共方法
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
async function getCommonXaidConfig(option, url, standardArguments, nineChapterWebxParams, sessionData, hostBranch, clusterId, requestFn) {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    data.std_args = standardArguments;
    return requestFn(`${host}/webx/xaid/config`, data, {
        header: {
            'X-Cluster-Id': clusterId,
            'X-Prod-Key': data.prod_key || '',
        },
        isWebx: true,
        needSign: true,
        // emulateJSON: true
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端webx更新用户信息请求
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
async function commonUpdateWebxUserInfo(option, url, standardArguments, nineChapterWebxParams, sessionData, hostBranch, clusterId, requestFn) {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    data.std_args = standardArguments;
    return requestFn(`${host}/webx/chapter/user/update`, data, {
        header: {
            'X-Cluster-Id': clusterId,
            'X-Prod-Key': data.prod_key || '',
        },
        isWebx: true,
        needSign: true,
        // emulateJSON: true
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
// 获取拉端策略
async function getCommonLaunchAppConfig(data, url, hostBranch, clusterId, requestFn) {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    return requestFn(`${host}/webx/chapter/invoke/config`, data, {
        header: {
            'X-Cluster-Id': clusterId,
            'X-Prod-Key': data.prod_key || '',
        },
        isWebx: true,
        needSign: true,
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
// 获取拉端策略V2
async function getCommonLaunchAppConfigV2(data, url, hostBranch, clusterId, requestFn) {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    return requestFn(`${host}/webx/v2/getInvokeConfig`, data, {
        header: {
            'X-Cluster-Id': clusterId,
            'X-Prod-Key': data.prod_key || '',
        },
        isWebx: true,
        needSign: true,
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
// 获取拉端状态
async function getCommonLaunchAppStatus(data, url, hostBranch, clusterId, requestFn) {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    return requestFn(`${host}/webx/chapter/invoke/status`, data, {
        header: {
            'X-Cluster-Id': clusterId,
            'X-Prod-Key': data.prod_key || '',
        },
        isWebx: true,
        needSign: true,
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
// 上报拉端事件
async function trackCommonLaunchAppEvent(data, url, hostBranch, clusterId, requestFn) {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    return requestFn(`${host}/webx/chapter/invoke/push`, data, {
        header: {
            'X-Cluster-Id': clusterId,
            'X-Prod-Key': data.prod_key || '',
        },
        isWebx: true,
        needSign: true,
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
// 上报拉端功能内部埋点
async function upCommonLaunchAppEvent(data, url, hostBranch, clusterId, requestFn) {
    const host = checkHttpsPrefix(url) ? url : getHostByEnv(hostBranch);
    return requestFn(`${host}/webx/chapter/invoke/tracking/user`, data, {
        header: {
            'X-Cluster-Id': clusterId,
            'X-Prod-Key': data.prod_key || '',
        },
        isWebx: true,
        needSign: true,
    }).then(res => Number(res.errno) === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
export { host, initPath, xposParamsMap, getHostByEnv, getWebxInitPath, businessRequest, commonInitProduct, commonInitProductV2, commonInitProductV3, getCommonPageConfig, getCommonPageBatchConfig, getCommonShareConfig, getCommonShareConfigV2, getCommonShareBatchConfig, getCommonShareBatchConfigV2, getCommonCoverConfig, getCommonXaidConfig, commonUpdateWebxUserInfo, getCommonLaunchAppConfig, getCommonLaunchAppConfigV2, getCommonLaunchAppStatus, trackCommonLaunchAppEvent, upCommonLaunchAppEvent };
